import { createContext, useContext, useState, useEffect } from "react";
import { getLocales } from "../lib/api";
import { DEFAULT_LOCALE } from "../lib/constants";

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("site_lang");
    if (saved) return saved;
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang.startsWith("pt")) return DEFAULT_LOCALE;
    if (browserLang.startsWith("es")) return "es";
    return DEFAULT_LOCALE;
  });

  const [supportedLangs, setSupportedLangs] = useState([
    { code: DEFAULT_LOCALE, label: "PT", name: "Português", flag: "🇵🇹" },
  ]);

  useEffect(() => {
    localStorage.setItem("site_lang", lang);
    document.documentElement.lang = lang.split("-")[0];
  }, [lang]);

  useEffect(() => {
    getLocales().then(data => {
      if (!Array.isArray(data)) return;
      const published = data.filter(l => l.published === 1 && l.active === 1);
      if (published.length > 0) {
        const mapped = published.map(l => ({
          code: l.code,
          label: l.label?.substring(0, 2).toUpperCase() || l.code.split("-")[0].toUpperCase(),
          name: l.label,
          flag: l.flag || "",
        }));
        setSupportedLangs(mapped);
        const saved = localStorage.getItem("site_lang");
        if (!saved) {
          const defaultLang = published.find(l => l.is_default === 1);
          if (defaultLang && !mapped.find(m => m.code === lang)) {
            setLang(defaultLang.code);
          }
        }
      }
    }).catch(() => {});
  }, []);

  const value = {
    lang,
    setLang,
    supportedLangs,
    currentLang: supportedLangs.find((l) => l.code === lang) || supportedLangs[0],
  };

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const context = useContext(LangContext);
  if (!context) {
    throw new Error("useLang must be used within a LangProvider");
  }
  return context;
}
